module.exports = __webpack_public_path__ + "resource/img/icons.d0311a7f.png";